import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

const initState = {
  email: null,
  membershipType: null,
  applicationStatus: null,
};

export const MembershipTaskListFormData = {
  name: "MembershipTaskListFormData",
  initialState: initState,
  section: [
    {
      title: "MembershipTaskListFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "MembershipTaskListFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "email",
              label: "Email",
              Field_Name: "Email",
              fieldType: FormFieldTypes.INPUT,
              dataField: "email",
              fieldSetting: {
                placeholder: "Email",
                allowSpace: false,
              },
              //  validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
              },
            },
            {
              id: "membershipType",
              label: "Membership Type",
              Field_Name: "Membership Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "membershipType",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  // { label: "City 1", value: 1 },
                  // { label: "City 2", value: 2 },
                  // { label: "City 3", value: 3 },
                ],
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
              },
            },
            {
              id: "applicationStatus",
              label: "Application Status",
              Field_Name: "Application Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "applicationStatus",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  // { label: "City 1", value: 1 },
                  // { label: "City 2", value: 2 },
                  // { label: "City 3", value: 3 },
                ],
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 ",
              },
            },
          ],
        },
      ],
    },
  ],
};
export const UpgradeMembershipTaskListFormData = {
  name: "MembershipTaskListFormData",
  initialState: initState,
  section: [
    {
      title: "MembershipTaskListFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "MembershipTaskListFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "email",
              label: "Email",
              Field_Name: "Email",
              fieldType: FormFieldTypes.INPUT,
              dataField: "email",
              fieldSetting: {
                placeholder: "Email",
                allowSpace: false,
              },
              //  validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
              },
            },
            // {
            //   id: "membershipType",
            //   label: "Membership Type",
            //   Field_Name: "Membership Type",
            //   fieldType: FormFieldTypes.SELECT,
            //   dataField: "membershipType",
            //   fieldSetting: {
            //     placeholder: "Select",
            //     options: [
            //       // { label: "City 1", value: 1 },
            //       // { label: "City 2", value: 2 },
            //       // { label: "City 3", value: 3 },
            //     ],
            //   },
            //   // validation: [{ type: validationTypes.REQUIRE }],
            //   style: {
            //     containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
            //   },
            // },
            {
              id: "applicationStatus",
              label: "Application Status",
              Field_Name: "Application Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "applicationStatus",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  // { label: "City 1", value: 1 },
                  // { label: "City 2", value: 2 },
                  // { label: "City 3", value: 3 },
                ],
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 ",
              },
            },
          ],
        },
      ],
    },
  ],
};
export const MembershipTaskListConfig = {
  columns: [
    {
      name: "Submission Date",
      fieldName: "submissionDate",
      colType: GridColumnType.DATE,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // },
      colSettings: {
        format: "DD-MMM-YYYY",
      },
      allowShort: false,
    },

    {
      name: "Name",
      fieldName: "fullName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Email Address",
      fieldName: "emailAddress",
      allowShort: false,
      // colStyle: {
      //     width: "40%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Application Type",
      fieldName: "membershipTypeName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Status",
      fieldName: "statusName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
export const UpgradeMembershipTaskListConfig = {
  columns: [
    {
      name: "Submission Date",
      fieldName: "submissionDate",
      colType: GridColumnType.DATE,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // },
      colSettings: {
        format: "DD-MMM-YYYY",
      },
      allowShort: false,
    },

    {
      name: "Name",
      fieldName: "fullName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Email Address",
      fieldName: "emailAddress",
      allowShort: false,
      // colStyle: {
      //     width: "40%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    // {
    //   name: "Application Type",
    //   fieldName: "membershipTypeName",
    //   allowShort: false,
    //   // colStyle: {
    //   //     width: "15%",
    //   //     textAlign: "center",
    //   //     color: "color",
    //   //     backgroundColor: "white"
    //   // }
    // },
    {
      name: "Status",
      fieldName: "statusName",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
